//import { mapGetters } from 'vuex'
export default {
  name: 'BillSummary',
  components: {},
  props: ['billDetail'],
  data () {
    return {

    }
  },
  computed: {
      /* ...mapGetters([
      'selectedState',
      'selectedServiceProvider',
      'selectedServiceProviderQuestion',
      'selectedAccountNumber'
       ])*/
  }
}



// WEBPACK FOOTER //
// ./src/components/BillSummary/component.js